export class CompanyDTO {
    CompanyID: number;
    CompanyName: string;
    SecurityKey: string;
    Active: boolean;
    Domain: string;
    IntegrationKey: string;
    MSTOffset: number;
    DefaultClearViewThemeID: number;
    LoginURL: string;
    NoProration: boolean;
    CallAtEnd: boolean;
    LocalLanguage: number; //ClearView.Admin.DTOs.Enums.LocalizationSetting
    ReadAccess: boolean;
    Partner: Partners;
    RealtimeEndpoint: string;
    PartnerIdentifier: string;
    IsTemplate: boolean;
    AllowPurge: boolean;
    TimeZoneInfoName: string;
    SourceTimeZone: string;
    AdditionalTimeZones: string[];
    isImpersonated: boolean | null;
    EnableSSO: boolean;
    SSOClientID?: string;
    SSOClientSecret?: string;
    SSOEncryptionMethod?: string;
    SSOIdentityProviderURL?: string;
    SSOProtocol?: string;
    SSOProvider?: string;
    SSOTransportAlgorithm?: string;
    SSOX509Certificate?: string;
    SSOIdPId?: string;
    SSOSamlBinding?: string;
    SSOSignedAssertions?: boolean;
    SSOSignAuthnRequests?: boolean;
    SSORollSigning?: boolean;
    SSORollEncryption?: boolean;    
    SSOHasMetadata?: boolean;
    SSOHasSigningKeys?: boolean;
    SSOHasEncryptionKeys?: boolean;
    FedRAMP: boolean = false;
}

export interface GroupTypeDTO {
    CompanyID: number,
    GroupTypeName: string,
    Assignable: boolean,
    BaseGroupType: number,
    GroupLevel: number,
    Active: boolean
}

export interface CompanyValueDTO {
    CompanyID: number,
    FieldID: number,
    FieldType: number,
    FieldName: string,
    DisplayName: string,
    NumericValue: number,
    BoolValue: boolean,
    TextValue: string,
    Visible: boolean,
    Customer: boolean,
    isDefault: boolean
}

export interface TimeZoneModel {
    TimeZone: string,
    Selected: boolean
}

export interface SalesPackageAssignmentWsto {
    PackageID: number,
    PackageName: string,
    Activated: boolean,
    AllUserAccess: boolean
}

export enum Partners {
    Unknown = -1,
    Direct = 0,
    Nice_inContact = 1,
    Five9 = 2,
    Serenova = 3,
    Genesys = 4,
    Cisco = 5,
    Amazon = 6,
    Avaya = 7,
    UJet = 8
}
